import { useMutation } from '@tanstack/react-query';
import { logout as logoutApi, LogoutResponse } from '@/api/auth';
import { toast } from '@/hooks/use-toast';

interface UseLogoutMutationOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export function useLogoutMutation(options?: UseLogoutMutationOptions) {
  return useMutation({
    mutationFn: logoutApi,
    onSuccess: () => {
      toast({
        title: 'Success',
        description: 'Logged out successfully',
      });
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      toast({
        title: 'Warning',
        description: error?.response?.data?.message || 'Logged out locally',
        variant: 'default',
      });
      options?.onError?.(error);
    },
  });
}



